<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="text-left">
                <!--<inter-card>
                    <h4 class="text-primary">Seleziona il tipo di pagamento che desideri utilizzare.</h4>
                    <p>Se scegli come metodo 'Carta di Credito', una volta approvata la tua richiesta
                        potrai procedere al pagamento direttamente da questo portale</p>
                </inter-card>-->
                <inter-card>
                    {{ user.data.society }}
                    <h4 class="text-primary">Come effettuare il pagamento.</h4>
                    <p>I biglietti devono essere pagati tramite Carta di Credito o Bonifico Bancario entro 
                        e non oltre la data ultima di apertura richieste della gara.
                        In seguito le coordinate:<br /><br />
                        F.C. INTERNAZIONALE MILANO S.p.A.<br />INTESA SAN PAOLO<br />
                        IBAN: &nbsp; &nbsp; IT58U0306909526100000005804<br />
                        SWIFT: &nbsp; &nbsp; BCITITMM<br />
                        CAUSALE: &nbsp; &nbsp; <strong style="color:#a29161;">Inter-{{ recap[0].value }} - nome societ&agrave;</strong><br />
                        Totale &nbsp; &nbsp; {{ recap[1].value }}<br /><br />
                        Importante: una volta effettuato il pagamento non sar&agrave; possibile modificare
                        la richiesta inserita in precedenza. Vi chiediamo quindi di procedere solo una volta
                        confermate definitivamente le numeriche e segnalarci l'avvenuto pagamento
                        utilizzando il tasto 'SEGNALA COME PAGATO'.<br /><br />
                        I biglietti saranno disponibili per il download dal terzo
                        giorno successivo alla data del pagamento.</p>
                </inter-card>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center" style="display:none;">
            <b-col cols="12" md="6" class="text-left">
                <inter-card
                        titleIcon="flaticon-euro"
                        title="Pagamento">
                    <inter-select
                            label="Metodo di pagamento"
                            v-model="payment"
                            :option-selected="payment"
                            :options="[
                                { name: 'Bonifico', value: 'bonifico'},
                                { name: 'Carta di credito', value: 'cc'}
                                ]"
                    ></inter-select>
                </inter-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    import InterSelect from "../../../../components/form/inter-select/InterSelect";
    import InterCard from "../../../../components/card/InterCard";
    import MatchRequest from "@/models/MatchRequest";
    import Utils from "@/utils";
    import Moment from 'moment';
    import User from "@/models/User";
    import _ from "lodash";

    export default {
        name: "SocietyMatchWizardsStepThree",
        components: {InterCard, InterSelect},
        props: {
            user: {
                type: Object,
                default: () => Object.assign({}, User)
            },
            paymentMethod: {
                type: String,
                default: 'bonifico'
            },
            matchRequest: {
                type: Object,
                default: () => Object.assign({}, MatchRequest)
            }
        },
        computed: {
            payment: {
                get: function () {
                    return this.paymentMethod
                },
                set: function (newValue) {
                    this.$emit('onChangePayment', newValue)
                }
            },
            recap: function () {
                let items = [];
                items.push({
                    label: 'Partita',
                    value: this.matchRequest.match.opponent
                });
                items.push({
                    label: 'Importo',
                    value: Utils.setCurrencyFormat(this.totalAmount)
                });
                return items;
            },
            juniorContacts: function () {
                const list = _.filter(this.matchRequest.details, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age < 18;
                });
                return _.sortBy(list, ['surname'])
            },
            seniorContacts: function () {
                const list = _.filter(this.matchRequest.details, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age >= 18;
                });
                return _.sortBy(list, ['surname'])
            },
            totalSenior: function () {
                return _.filter(this.seniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalJunior: function () {
                return _.filter(this.juniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalAmount: function () {
                return (this.totalJunior + this.totalSenior) * this.matchRequest.match.price;
            }
        },
        methods: {
            validate: function () {

                if (this.paymentMethod) {
                    return true;
                } else {
                    this.$bvToast.toast('Devi selezionare una metodo di pagamento', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }

            },
        }
    }
</script>

<style scoped>

</style>
